// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {App_context} from 'hola_app_context';
import React, {useCallback, useContext, useEffect, useRef,
    useState} from 'react';
import {useLocation} from 'react-router-dom';
// @ts-ignore
import {get, set} from '/util/storage.js';
import hola_opt from 'hola_opt';

export const Intercom = ({with_intercom, app_id, need_plus}:
    {with_intercom: boolean, app_id: string, need_plus: boolean})=>{
    const {is_plus, user} = useContext(App_context);
    const {pathname} = useLocation();
    const inited_ref = useRef({init: false});
    useEffect(()=>{
        const is_debug = location.href.indexOf('debug_ui')>-1;
        const is_active = need_plus && is_plus || !need_plus;
        if (hola_opt.is_eu)
        {
            if (!hola_opt.cookie_value_parsed
                || !hola_opt.cookie_value_parsed.mark)
            {
                return;
            }
        }
        if (is_active && (is_debug || with_intercom))
        {
            if (inited_ref.current.init)
            {
                // @ts-ignore
                window.Intercom('update');
            }
            else
            {
                let user_id = user ? user.hola_uid : get('intercom_id');
                if (!user_id)
                {
                    user_id = Math.round(Math.random()*100000);
                    set('intercom_id', user_id);
                }
                const init_interval = setInterval(()=>{
                    // @ts-ignore
                    if (window.Intercom)
                    {
                        // @ts-ignore
                        window.Intercom('boot', {
                            api_base: 'https://api-iam.intercom.io',
                            app_id,
                            user_id,
                            name: user ? user.displayName : 'Guest',
                            email: user && user.emails?.length > 0 ?
                                user.emails[0]?.value : '',
                            created_at: user ? user.verified : undefined,
                        });
                        clearInterval(init_interval);
                        inited_ref.current.init = true;
                        document.dispatchEvent(new Event('intercom_inited'));
                    }
                }, 300);
                return ()=>{
                    clearInterval(init_interval);
                };
            }
        }
    }, [pathname, is_plus]);
    return <div/>;
};

export const use_intercom = (shown?: boolean)=>{
    // @ts-ignore
    const [inited, set_inited] = useState(typeof window.Intercom=='function');
    const [visible, set_visible] = useState(shown);
    useEffect(()=>{
        document.addEventListener('intercom_inited', ()=>set_inited(true));
    }, []);
    const show = useCallback(()=>{ set_visible(true); }, []);
    const hide = useCallback(()=>{ set_visible(false); }, []);
    useEffect(()=>{
        if (!inited)
            return;
        // @ts-ignore
        window.Intercom('update', {hide_default_launcher: !visible});
    }, [inited, visible]);
    return {inited, visible, show, hide};
};
